import { Avatar, Button, Dropdown, Layout, Image } from 'antd';
import {
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  SettingOutlined,
  UserOutlined,
} from '@ant-design/icons';
import React, { FunctionComponent } from 'react';
import { useStore } from '../../../helpers/use-store';
import { observer } from 'mobx-react-lite';
import { useResponsiveReady } from '../../../hooks/use-responive-ready';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../../../components/language-switcher/language-switcher';

const { Header: AntHeader } = Layout;

export interface Props {
  collapsed: boolean;
  setCollapsed: (flag: boolean) => void;
}

const Header: FunctionComponent<Props> = ({ collapsed, setCollapsed }) => {
  const { isMobile } = useResponsiveReady();
  const {
    dataStore: { userStore },
  } = useStore();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const avatarDropdownItems = [
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: t('header.settings'),
      onClick: () => navigate('/settings/profile'),
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: t('header.logout'),
      onClick: () => userStore.logout(),
    },
  ];

  return (
    <AntHeader
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      {isMobile ? (
        <Button
          type="text"
          style={{ marginLeft: !collapsed ? 200 : 0 }}
          icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          onClick={() => setCollapsed(!collapsed)}
          className="menu-trigger"
        />
      ) : (
        <span />
      )}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <LanguageSwitcher />
        <Dropdown
          menu={{ items: avatarDropdownItems }}
          placement="bottomRight"
          arrow
        >
          <Avatar
            icon={<UserOutlined />}
            size={'large'}
            style={{ border: '1px solid #e3e3e3', cursor: 'pointer' }}
            src={
              <Image
                referrerPolicy={'no-referrer'}
                src={`${userStore.currentUser.profileImage}?date=${Date.now()}`}
                preview={false}
              />
            }
          />
        </Dropdown>
      </div>
    </AntHeader>
  );
};

export default observer(Header);
